import React from "react";
import { Field, Form, Formik } from "formik";
import { useCookies } from "react-cookie";
import * as Yup from "yup";
import { patchData, postData } from "../../../../../../services";
import { boolStatusData, statusData, userRoles } from "../../../../../../helpers/staticData";
import SelectDropdown from "../../../../../molecules/Dropdown";
import toast from "react-hot-toast";
import {
  confimationStyles,
  errorStyles,
} from "../../../../../../assets/styles/toast";

const UserForm = ({ onClose, initialValues, id, refetchData }) => {
  const [cookies] = useCookies(["b_t", "bid"]);

  const initialData = {
    name: initialValues?.name || null,
    email: initialValues?.email || null,
    role: initialValues?.role || null,
    is_active: initialValues?.is_active || false,
    password: null,
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    role: Yup.string().required("Role is required"),
  });

  const handleSubmit = async (values) => {
    const res = await postData({
      endpoint: "BusinessUser/addUserInBusiness",
      token: cookies.b_t,
      data: { ...values, business_id: cookies.bid },
    });

    if (res?.data?.status) {
      toast.success("User Added Successfully", {
        style: confimationStyles,
        duration: 1000,
      });
      onClose();
      refetchData();
    } else {
      toast.error(res?.data?.message, { style: errorStyles, duration: 1000 });
      onClose();
    }
  };

  const handleEdit = async (values) => {
    try {
      const res = await patchData({
        endpoint: "BusinessUser/editUserInBusiness",
        token: cookies.b_t,
        data: { ...values, business_id: cookies.bid },
        params: { user_id: id },
      });

      if (res.status) {
        toast.success("User Updated Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
        refetchData();
      } else {
        toast.error(res.message, { style: confimationStyles, duration: 1000 });
      }

      onClose();
    } catch (error) {}
  };

  return (
    <Formik
      initialValues={initialData}
      validationSchema={validationSchema}
      key={id}
      enableReinitialize
      onSubmit={handleSubmit}
    >
      {({
        dirty,
        isValid,
        values,
        errors,
        setFieldValue,
        handleBlur,
        handleChange,
      }) => (
        <Form>
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <Field type="text" id="name" name="name" placeholder="Enter Name" />
          </div>

          <div className="form-group mt-3">
            <label htmlFor="email">Email</label>
            <Field
              type="email"
              id="email"
              name="email"
              placeholder="Enter Email"
            />
          </div>

          {initialData?.role !== "Owner" && (
            <>
              <div className="form-group mt-3">
                <label htmlFor="role_id">Select Role</label>
                <SelectDropdown
                  data={userRoles}
                  placeholder="Select Role"
                  onChange={(option) => {
                    setFieldValue("role", option);
                  }}
                  selectedValue={initialValues?.role}
                />
              </div>

              {initialValues && (
                <div className="form-group mt-3">
                  <label htmlFor="role_id">Status</label>
                  <SelectDropdown
                    data={boolStatusData}
                    placeholder="Select Status"
                    onChange={(option) => {
                      setFieldValue("is_active", option);
                    }}
                    selectedValue={initialData?.is_active}
                  />
                </div>
              )}
            </>
          )}

          <div className="d-flex justify-content-end mt-3">
            {initialValues ? (
              <button
                type="button"
                className="btn btn-primary"
                disabled={!isValid}
                onClick={() => handleEdit(values)}
              >
                Update
              </button>
            ) : (
              <button
                type="submit"
                className="btn btn-primary w-20"
                disabled={!isValid || !dirty}
              >
                Add
              </button>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default UserForm;
